import React from 'react';

import { IconTypes } from 'constants/Constants';
import { ReactComponent as AddFilledIcon, ReactComponent as AddOutlinedIcon } from 'styles/svg/addOutlined.svg';
import { ReactComponent as AddChart } from 'styles/svg/addChart.svg';
import { ReactComponent as AddSectionAboveIcon } from 'styles/svg/addSectionAbove.svg';
import { ReactComponent as AddSectionBelowIcon } from 'styles/svg/addSectionBelow.svg';
import { ReactComponent as AddCategoryIcon } from 'styles/svg/addCategory.svg';
import { ReactComponent as ArrowRightIcon } from 'styles/svg/arrowRight.svg';
import { ReactComponent as ArrowLeftIcon } from 'styles/svg/arrowLeft.svg';
import { ReactComponent as ArrowUpIcon } from 'styles/svg/arrowUp.svg';
import { ReactComponent as ArrowDownIcon } from 'styles/svg/arrowDown.svg';
import { ReactComponent as ArrowFirstPageIcon } from 'styles/svg/arrowFirstPage.svg';
import { ReactComponent as ArrowLastPageIcon } from 'styles/svg/arrowLastPage.svg';
import { ReactComponent as AttachmentIcon } from 'styles/svg/attachment.svg';
import { ReactComponent as BenchMarksIcon } from 'styles/svg/benchmarks.svg';
import { ReactComponent as BlockIcon } from 'styles/svg/block.svg';
import { ReactComponent as CardModeIcon } from 'styles/svg/cardMode.svg';
import { ReactComponent as CheckCircleLargeIcon } from 'styles/svg/checkCircleLarge.svg';
import { ReactComponent as CheckCircleSmallIcon } from 'styles/svg/checkCircleSmall.svg';
import { ReactComponent as CheckIcon } from 'styles/svg/check.svg';
import { ReactComponent as CheckIndeterminateIcon } from 'styles/svg/checkIndeterminateWhite.svg';
import { ReactComponent as ChevronIcon } from 'styles/svg/chevron.svg';
import { ReactComponent as ChevronUpIcon } from 'styles/svg/chevronUp.svg';
import { ReactComponent as ChevronRightIcon } from 'styles/svg/chevronRight.svg';
import { ReactComponent as ChevronLeftIcon } from 'styles/svg/chevronLeft.svg';
import { ReactComponent as ClusterIcon } from 'styles/svg/cluster.svg';
import { ReactComponent as CogWheelIcon } from 'styles/svg/cogwheel.svg';
import { ReactComponent as CommentIcon } from 'styles/svg/comment.svg';
import { ReactComponent as CompareIcon } from 'styles/svg/compare.svg';
import { ReactComponent as CreateNewsletterIcon } from 'styles/svg/createNewsletter.svg';
import { ReactComponent as CrossCircleLargeIcon } from 'styles/svg/crossCircleLarge.svg';
import { ReactComponent as CrossCircleSmallIcon } from 'styles/svg/crossCircleSmall.svg';
import { ReactComponent as CrossFilledIcon } from 'styles/svg/crossCircleSmallFilled.svg';
import { ReactComponent as CrossIcon } from 'styles/svg/cross.svg';
import { ReactComponent as ChangeOrderIcon } from 'styles/svg/changeOrder.svg';
import { ReactComponent as DashboardIcon } from 'styles/svg/dashboard.svg';
import { ReactComponent as DateRangeIcon } from 'styles/svg/dateRange.svg';
import { ReactComponent as DotFilledIcon } from 'styles/svg/dot.svg';
import { ReactComponent as DotOutlinedIcon } from 'styles/svg/dotOutlined.svg';
import { ReactComponent as DotsBackgroundIcon } from 'styles/svg/dotsBackground.svg';
import { ReactComponent as DotsIcon } from 'styles/svg/dots.svg';
import { ReactComponent as DownloadIcon } from 'styles/svg/download.svg';
import { ReactComponent as DuplicateIcon } from 'styles/svg/duplicate.svg';
import { ReactComponent as EditIcon } from 'styles/svg/edit.svg';
import { ReactComponent as ExpandArrowsIcon } from 'styles/svg/expandArrows.svg';
import { ReactComponent as ExpandIcon } from 'styles/svg/expand.svg';
import { ReactComponent as FilterIcon } from 'styles/svg/filter.svg';
import { ReactComponent as FilterSettingsIcon } from 'styles/svg/filterSettings.svg';
import { ReactComponent as FormatImageBottomIcon } from 'styles/svg/formatImgBottom.svg';
import { ReactComponent as FormatImageCropIcon } from 'styles/svg/formatImgCrop.svg';
import { ReactComponent as FormatImageLeftIcon } from 'styles/svg/formatImgLeft.svg';
import { ReactComponent as FormatImageLeftBottomIcon } from 'styles/svg/formatImgLeftBottom.svg';
import { ReactComponent as FormatImageRightIcon } from 'styles/svg/formatImgRight.svg';
import { ReactComponent as FormatImageRightBottomIcon } from 'styles/svg/formatImgRightBottom.svg';
import { ReactComponent as FormatImgTopIcon } from 'styles/svg/formatImgTop.svg';
import { ReactComponent as FormatImgHeroIcon } from 'styles/svg/formatImgHero.svg';
import { ReactComponent as FormatImgCenterCenterIcon } from 'styles/svg/formatImgCenterCenter.svg';
import { ReactComponent as FormatTextAlignLeft } from 'styles/svg/formatTextAlignLeft.svg';
import { ReactComponent as FormatTextAlignCenter } from 'styles/svg/formatTextAlignCenter.svg';
import { ReactComponent as FormatTextAlignRight } from 'styles/svg/formatTextAlignRight.svg';
import { ReactComponent as HandleBarIcon } from 'styles/svg/handlebar.svg';
import { ReactComponent as GridModeIcon } from 'styles/svg/gridMode.svg';
import { ReactComponent as HelpIcon } from 'styles/svg/help.svg';
import { ReactComponent as HistoryIcon } from 'styles/svg/history.svg';
import { ReactComponent as InboxIcon } from 'styles/svg/inbox.svg';
import { ReactComponent as IndentIcon } from 'styles/svg/formatIndentIncrease.svg';
import { ReactComponent as LikeFilledIcon } from 'styles/svg/likeSolid.svg';
import { ReactComponent as LikeIcon } from 'styles/svg/like.svg';
import { ReactComponent as LinkIcon } from 'styles/svg/link.svg';
import { ReactComponent as LinkExternalIcon } from 'styles/svg/linkExternal.svg';
import { ReactComponent as ListModeIcon } from 'styles/svg/listMode.svg';
import { ReactComponent as LockIcon } from 'styles/svg/lock.svg';
import { ReactComponent as MasonryIcon } from 'styles/svg/masonry.svg';
import { ReactComponent as MenuIcon } from 'styles/svg/menu.svg';
import { ReactComponent as MovieIcon } from 'styles/svg/movie.svg';
import { ReactComponent as MinimizeIcon } from 'styles/svg/minimizeArrows.svg';
import { ReactComponent as NavigateDownLargeIcon } from 'styles/svg/navigateDownLarge.svg';
import { ReactComponent as NavigateLeftLargeIcon } from 'styles/svg/navigateLeftLarge.svg';
import { ReactComponent as NavigateRightLargeIcon } from 'styles/svg/navigateRightLarge.svg';
import { ReactComponent as NewsletterIcon } from 'styles/svg/newsletterClosed.svg';
import { ReactComponent as NewsletterOpenedIcon } from 'styles/svg/newsletterOpened.svg';
import { ReactComponent as NotificationIcon } from 'styles/svg/notification.svg';
import { ReactComponent as PaletteIcon } from 'styles/svg/palette.svg';
import { ReactComponent as PlusIcon } from 'styles/svg/plus.svg';
import { ReactComponent as MinusIcon } from 'styles/svg/minus.svg';
import { ReactComponent as PdfIcon } from 'styles/svg/pdf.svg';
import { ReactComponent as PhotoIcon } from 'styles/svg/photo.svg';
import { ReactComponent as PinIcon } from 'styles/svg/pin.svg';
import { ReactComponent as PlayIcon } from 'styles/svg/play.svg';
import { ReactComponent as PlayCircleIcon } from 'styles/svg/playCircle.svg';
import { ReactComponent as PauseCircleIcon } from 'styles/svg/pauseCircle.svg';
import { ReactComponent as PptIcon } from 'styles/svg/ppt.svg';
import { ReactComponent as PresentIcon } from 'styles/svg/present.svg';
import { ReactComponent as PreviewIcon } from 'styles/svg/previewEye.svg';
import { ReactComponent as RemoveCategoryIcon } from 'styles/svg/removeCategory.svg';
import { ReactComponent as RenewIcon } from 'styles/svg/renew.svg';
import { ReactComponent as ReportIcon } from 'styles/svg/report.svg';
import { ReactComponent as ReportLibraryIcon } from 'styles/svg/reportLibrary.svg';
import { ReactComponent as ResetIcon } from 'styles/svg/reset.svg';
import { ReactComponent as SendIcon } from 'styles/svg/send.svg';
import { ReactComponent as ScheduleIcon } from 'styles/svg/schedule.svg';
import { ReactComponent as SearchIcon } from 'styles/svg/search.svg';
import { ReactComponent as SettingsFilledIcon } from 'styles/svg/settingsFilled.svg';
import { ReactComponent as SettingsOutlinedIcon } from 'styles/svg/settingsOutlined.svg';
import { ReactComponent as SettingsOffIcon } from 'styles/svg/settingsOff.svg';
import { ReactComponent as ShareIcon } from 'styles/svg/share.svg';
import { ReactComponent as SortIcon } from 'styles/svg/sort.svg';
import { ReactComponent as StatisticsIcon } from 'styles/svg/statistics.svg';
import { ReactComponent as SubscriptionsIcon } from 'styles/svg/subscriptions.svg';
import { ReactComponent as SummarizeIcon } from 'styles/svg/dynamic_feed.svg';
import { ReactComponent as TranslateIcon } from 'styles/svg/translate.svg';
import { ReactComponent as TrashIcon } from 'styles/svg/trash.svg';
import { ReactComponent as UserIcon } from 'styles/svg/user.svg';
import { ReactComponent as UserRemoveIcon } from 'styles/svg/userRemove.svg';
import { ReactComponent as UsersIcon } from 'styles/svg/users.svg';
import { ReactComponent as UsersAddIcon } from 'styles/svg/usersAdd.svg';
import { ReactComponent as UnfoldMoreIcon } from 'styles/svg/unfoldMore.svg';
import { ReactComponent as UnfoldLessIcon } from 'styles/svg/unfoldLess.svg';
import { ReactComponent as VisibilityOffIcon } from 'styles/svg/visibility_off.svg';
import { ReactComponent as VisibilityOnIcon } from 'styles/svg/visibility_on.svg';
import { ReactComponent as WarningIcon } from 'styles/svg/warning.svg';
import { ReactComponent as ErrorIcon } from 'styles/svg/error.svg';
import { ReactComponent as DesktopIcon } from 'styles/svg/desktop.svg';
import { ReactComponent as PhoneIcon } from 'styles/svg/phone.svg';
import { ReactComponent as LoginIcon } from 'styles/svg/login.svg';
import { ReactComponent as LogoutIcon } from 'styles/svg/logout.svg';

import { ReactComponent as MonitoringSources } from 'styles/svg/monitoring-sources.svg';
import { ReactComponent as MonitoringProfiles } from 'styles/svg/monitoring-profiles.svg';
import { ReactComponent as MonitoringPosts } from 'styles/svg/monitoring-posts.svg';
import { ReactComponent as MonitoringCategories } from 'styles/svg/monitoring-categories.svg';
import { ReactComponent as MonitoringQueries } from 'styles/svg/monitoring-queries.svg';
import { ReactComponent as MonitoringSites } from 'styles/svg/monitoring-sites.svg';
import { ReactComponent as MonitoringLogs } from 'styles/svg/monitoring-logs.svg';

import { ReactComponent as MonitoringLogErrorIncrease } from 'styles/svg/monitoringLogErrorIncrease.svg';
import { ReactComponent as MonitoringLogErrorDecrease } from 'styles/svg/monitoringLogErrorDecrease.svg';
import { ReactComponent as MonitoringLogErrorConsume } from 'styles/svg/monitoringLogErrorConsume.svg';
import { ReactComponent as MonitoringLogErrorFetch } from 'styles/svg/monitoringLogErrorFetch.svg';

const getIconFromConstant = (icon, getIconClassName, props) => {
	switch (icon) {
		case IconTypes.MONITORING_SOURCES:
			return <MonitoringSources className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_PROFILES:
			return <MonitoringProfiles className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_POSTS:
			return <MonitoringPosts className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_CATEGORIES:
			return <MonitoringCategories className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_QUERIES:
			return <MonitoringQueries className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_SITES:
			return <MonitoringSites className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_LOGS:
			return <MonitoringLogs className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_LOG_ERROR_INCREASE:
			return <MonitoringLogErrorIncrease className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_LOG_ERROR_DECREASE:
			return <MonitoringLogErrorDecrease className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_LOG_ERROR_CONSUME:
			return <MonitoringLogErrorConsume className={getIconClassName()} {...props} />;
		case IconTypes.MONITORING_LOG_ERROR_FETCH:
			return <MonitoringLogErrorFetch className={getIconClassName()} {...props} />;
		// Post qualify icons
		case IconTypes.CROSS_CIRCLE_SMALL:
			return <CrossCircleSmallIcon className={getIconClassName('cross')} {...props} />;
		case IconTypes.CROSS_CIRCLE_LARGE:
			return <CrossCircleLargeIcon className={getIconClassName('cross')} {...props} />;
		case IconTypes.CHECK_CIRCLE_SMALL:
			return <CheckCircleSmallIcon className={getIconClassName('check')} {...props} />;
		case IconTypes.CHECK_CIRCLE_LARGE:
			return <CheckCircleLargeIcon className={getIconClassName('check')} {...props} />;
		// Navigate large icons
		case IconTypes.NAVIGATE_DOWN_LARGE:
			return <NavigateDownLargeIcon className={getIconClassName('icon_rotate180')} {...props} />;
		case IconTypes.NAVIGATE_LEFT_LARGE:
			return <NavigateLeftLargeIcon className={getIconClassName('icon_rotate180')} {...props} />;
		case IconTypes.NAVIGATE_RIGHT_LARGE:
			return <NavigateRightLargeIcon className={getIconClassName('icon_rotate180')} {...props} />;
		// Image format icons
		case IconTypes.FORMAT_IMAGE_LEFT:
			return <FormatImageLeftIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_LEFT_BOTTOM:
			return <FormatImageLeftBottomIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_RIGHT:
			return <FormatImageRightIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_RIGHT_BOTTOM:
			return <FormatImageRightBottomIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_TOP:
			return <FormatImgTopIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_HERO:
			return <FormatImgHeroIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_BOTTOM:
			return <FormatImageBottomIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_CENTER_CENTER:
			return <FormatImgCenterCenterIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_IMAGE_CROP:
			return <FormatImageCropIcon className={getIconClassName()} {...props} />;
		// Other icons
		case IconTypes.ADD_CHART:
			return <AddChart className={getIconClassName()} {...props} />;
		case IconTypes.ADD_SECTION_ABOVE:
			return <AddSectionAboveIcon className={getIconClassName()} {...props} />;
		case IconTypes.ADD_SECTION_BELOW:
			return <AddSectionBelowIcon className={getIconClassName()} {...props} />;
		case IconTypes.ADD_CATEGORY:
			return <AddCategoryIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_RIGHT:
			return <ArrowRightIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_LEFT:
			return <ArrowLeftIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_UP:
			return <ArrowUpIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_DOWN:
			return <ArrowDownIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_FIRST_PAGE:
			return <ArrowFirstPageIcon className={getIconClassName()} {...props} />;
		case IconTypes.ARROW_LAST_PAGE:
			return <ArrowLastPageIcon className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_TEXT_ALIGN_LEFT:
			return <FormatTextAlignLeft className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_TEXT_ALIGN_CENTER:
			return <FormatTextAlignCenter className={getIconClassName()} {...props} />;
		case IconTypes.FORMAT_TEXT_ALIGN_RIGHT:
			return <FormatTextAlignRight className={getIconClassName()} {...props} />;
		case IconTypes.CROSS:
			return <CrossIcon className={getIconClassName()} {...props} />;
		case IconTypes.ATTACHMENT:
			return <AttachmentIcon className={getIconClassName()} {...props} />;
		case IconTypes.GRID_MODE:
			return <GridModeIcon className={getIconClassName()} {...props} />;
		case IconTypes.CROSS_CIRCLE_SMALL_FILLED:
			return <CrossFilledIcon className={getIconClassName()} {...props} />;
		case IconTypes.PIN:
			return <PinIcon className={getIconClassName()} {...props} />;
		case IconTypes.PHOTO:
			return <PhotoIcon className={getIconClassName()} {...props} />;
		case IconTypes.PRESENT:
			return <PresentIcon className={getIconClassName()} {...props} />;
		case IconTypes.PREVIEW:
			return <PreviewIcon className={getIconClassName()} {...props} />;
		case IconTypes.EDIT:
			return <EditIcon className={getIconClassName()} {...props} />;
		case IconTypes.SEARCH:
			return <SearchIcon className={getIconClassName()} {...props} />;
		case IconTypes.SETTINGS_FILLED:
			return <SettingsFilledIcon className={getIconClassName()} {...props} />;
		case IconTypes.RESET:
			return <ResetIcon className={getIconClassName()} {...props} />;
		case IconTypes.CHEVRON_UP:
			return <ChevronUpIcon className={getIconClassName('icon_rotate180')} {...props} />;
		case IconTypes.CHEVRON_DOWN:
			return <ChevronIcon className={getIconClassName('icon_rotate180')} {...props} />;
		case IconTypes.CHEVRON_RIGHT:
			return <ChevronRightIcon className={getIconClassName('icon_rotate90')} {...props} />;
		case IconTypes.CHEVRON_LEFT:
			return <ChevronLeftIcon className={getIconClassName('icon_rotate90')} {...props} />;
		case IconTypes.DOTS:
			return <DotsIcon className={getIconClassName()} {...props} />;
		case IconTypes.DOTS_BACKGROUND:
			return <DotsBackgroundIcon className={getIconClassName()} {...props} />;
		case IconTypes.DOT_FILLED:
			return <DotFilledIcon className={getIconClassName()} {...props} />;
		case IconTypes.DOT_OUTLINED:
			return <DotOutlinedIcon className={getIconClassName()} {...props} />;
		case IconTypes.DUPLICATE:
			return <DuplicateIcon className={getIconClassName()} {...props} />;
		case IconTypes.LIKE:
			return <LikeIcon className={getIconClassName()} {...props} />;
		case IconTypes.LIKE_FILLED:
			return <LikeFilledIcon className={getIconClassName()} {...props} />;
		case IconTypes.COMMENT:
			return <CommentIcon className={getIconClassName()} {...props} />;
		case IconTypes.USER:
			return <UserIcon className={getIconClassName()} {...props} />;
		case IconTypes.USER_REMOVE:
			return <UserRemoveIcon className={getIconClassName()} {...props} />;
		case IconTypes.USERS_ADD:
			return <UsersAddIcon className={getIconClassName()} {...props} />;
		case IconTypes.NOTIFICATION:
			return <NotificationIcon className={getIconClassName()} {...props} />;
		case IconTypes.SORT:
			return <SortIcon className={getIconClassName()} {...props} />;
		case IconTypes.SEND:
			return <SendIcon className={getIconClassName()} {...props} />;
		case IconTypes.CLUSTER:
			return <ClusterIcon className={getIconClassName()} {...props} />;
		case IconTypes.HELP:
			return <HelpIcon className={getIconClassName()} {...props} />;
		case IconTypes.LIST_MODE:
			return <ListModeIcon className={getIconClassName()} {...props} />;
		case IconTypes.CARD_MODE:
			return <CardModeIcon className={getIconClassName()} {...props} />;
		case IconTypes.SHARE:
			return <ShareIcon className={getIconClassName()} {...props} />;
		case IconTypes.LOCK:
			return <LockIcon className={getIconClassName()} {...props} />;
		case IconTypes.TRASH:
			return <TrashIcon className={getIconClassName()} {...props} />;
		case IconTypes.TRANSLATE:
			return <TranslateIcon className={getIconClassName()} {...props} />;
		case IconTypes.SUMMARIZE:
			return <SummarizeIcon className={getIconClassName()} {...props} />;
		case IconTypes.VISIBILITY_OFF:
			return <VisibilityOffIcon className={getIconClassName()} {...props} />;
		case IconTypes.VISIBILITY_ON:
			return <VisibilityOnIcon className={getIconClassName()} {...props} />;
		case IconTypes.FILTER:
			return <FilterIcon className={getIconClassName()} {...props} />;
		case IconTypes.FILTER_SETTINGS:
			return <FilterSettingsIcon className={getIconClassName()} {...props} />;
		case IconTypes.SETTINGS_OUTLINED:
			return <SettingsOutlinedIcon className={getIconClassName()} {...props} />;
		case IconTypes.SETTINGS_OFF:
			return <SettingsOffIcon className={getIconClassName()} {...props} />;
		case IconTypes.ADD_OUTLINED:
			return <AddOutlinedIcon className={getIconClassName()} {...props} />;
		case IconTypes.NEWSLETTER_CLOSED:
			return <NewsletterIcon className={getIconClassName()} {...props} />;
		case IconTypes.NEWSLETTER_OPENED:
			return <NewsletterOpenedIcon className={getIconClassName()} {...props} />;
		case IconTypes.USERS:
			return <UsersIcon className={getIconClassName()} {...props} />;
		case IconTypes.MAIL:
			return <NewsletterIcon className={getIconClassName()} {...props} />;
		case IconTypes.REMOVE_CATEGORY:
			return <RemoveCategoryIcon className={getIconClassName()} {...props} />;
		case IconTypes.REPORT:
			return <ReportIcon className={getIconClassName()} {...props} />;
		case IconTypes.RENEW:
			return <RenewIcon className={getIconClassName()} {...props} />;
		case IconTypes.SUBSCRIPTIONS:
			return <SubscriptionsIcon className={getIconClassName()} {...props} />;
		case IconTypes.REPORT_LIBRARY:
			return <ReportLibraryIcon className={getIconClassName()} {...props} />;
		case IconTypes.PDF:
			return <PdfIcon className={getIconClassName()} {...props} />;
		case IconTypes.PPT:
			return <PptIcon className={getIconClassName()} {...props} />;
		case IconTypes.CHECK:
			return <CheckIcon className={getIconClassName()} {...props} />;
		case IconTypes.CHECK_INDETERMINATE:
			return <CheckIndeterminateIcon className={getIconClassName()} {...props} />;
		case IconTypes.DOWNLOAD:
			return <DownloadIcon className={getIconClassName()} {...props} />;
		case IconTypes.COMPARE:
			return <CompareIcon className={getIconClassName()} {...props} />;
		case IconTypes.MOVIE:
			return <MovieIcon className={getIconClassName()} {...props} />;
		case IconTypes.ADD_FILLED:
			return <AddFilledIcon className={getIconClassName()} {...props} />;
		case IconTypes.SCHEDULE:
			return <ScheduleIcon className={getIconClassName()} {...props} />;
		case IconTypes.EXPAND_ARROWS:
			return <ExpandArrowsIcon className={getIconClassName()} {...props} />;
		case IconTypes.EXPAND:
			return <ExpandIcon className={getIconClassName()} {...props} />;
		case IconTypes.MINIMIZE_ARROWS:
			return <MinimizeIcon className={getIconClassName()} {...props} />;
		case IconTypes.LINK:
			return <LinkIcon className={getIconClassName()} {...props} />;
		case IconTypes.LINK_EXTERNAL:
			return <LinkExternalIcon className={getIconClassName()} {...props} />;
		case IconTypes.COG_WHEEL:
			return <CogWheelIcon className={getIconClassName()} {...props} />;
		case IconTypes.STATISTICS:
			return <StatisticsIcon className={getIconClassName()} {...props} />;
		case IconTypes.HISTORY:
			return <HistoryIcon className={getIconClassName()} {...props} />;
		case IconTypes.INBOX:
			return <InboxIcon className={getIconClassName()} {...props} />;
		case IconTypes.INDENT:
			return <IndentIcon className={getIconClassName()} {...props} />;
		case IconTypes.MENU:
			return <MenuIcon className={getIconClassName()} {...props} />;
		case IconTypes.MASONRY:
			return <MasonryIcon className={getIconClassName()} {...props} />;
		case IconTypes.DASHBOARD:
			return <DashboardIcon className={getIconClassName()} {...props} />;
		case IconTypes.PLAY_CIRCLE:
			return <PlayCircleIcon className={getIconClassName()} {...props} />;
		case IconTypes.PAUSE_CIRCLE:
			return <PauseCircleIcon className={getIconClassName()} {...props} />;
		case IconTypes.PLAY:
			return <PlayIcon className={getIconClassName()} {...props} />;
		case IconTypes.PLAY_FLIPPED:
			return <PlayIcon className={getIconClassName('icon_rotate180')} {...props} />;
		case IconTypes.BENCHMARKS:
			return <BenchMarksIcon className={getIconClassName()} {...props} />;
		case IconTypes.HANDLEBAR:
			return <HandleBarIcon className={getIconClassName()} {...props} />;
		case IconTypes.WARNING:
			return <WarningIcon className={getIconClassName()} {...props} />;
		case IconTypes.ERROR:
			return <ErrorIcon className={getIconClassName()} {...props} />;
		case IconTypes.BLOCK:
			return <BlockIcon className={getIconClassName()} {...props} />;
		case IconTypes.DATE_RANGE:
			return <DateRangeIcon className={getIconClassName()} {...props} />;
		case IconTypes.UNFOLD_MORE:
			return <UnfoldMoreIcon className={getIconClassName()} {...props} />;
		case IconTypes.UNFOLD_LESS:
			return <UnfoldLessIcon className={getIconClassName()} {...props} />;
		case IconTypes.DESKTOP:
			return <DesktopIcon className={getIconClassName()} {...props} />;
		case IconTypes.PHONE:
			return <PhoneIcon className={getIconClassName()} {...props} />;
		case IconTypes.PLUS:
			return <PlusIcon className={getIconClassName()} {...props} />;
		case IconTypes.MINUS:
			return <MinusIcon className={getIconClassName()} {...props} />;
		case IconTypes.PALETTE:
			return <PaletteIcon className={getIconClassName()} {...props} />;
		case IconTypes.CHANGE_ORDER:
			return <ChangeOrderIcon className={getIconClassName()} {...props} />;
		case IconTypes.CREATE_NEWSLETTER:
			return <CreateNewsletterIcon className={getIconClassName()} {...props} />;
		case IconTypes.LOGIN:
			return <LoginIcon className={getIconClassName()} {...props} />;
		case IconTypes.LOGOUT:
			return <LogoutIcon className={getIconClassName()} {...props} />;
		default:
			return null;
	}
};

export default getIconFromConstant;
